const productGenerator = {

  questionaire: [], //Question

  registerRadioQuestion: function (nameAttribute) {
    this.questionaire.push(new Question(`radio-${nameAttribute}`));
  },

  registerContextDependendCheckbox: function (nameAttribute) {
    this.questionaire.push(new Question(`ctx-checkbox-${nameAttribute}`));
  },

  registerChecklist: function (nameAttribute) {
    this.questionaire.push(new Question(`checklist-${nameAttribute}`));
  },

  getQuestionByName: function (name) {
    return this.questionaire.find(e => e.name == name);
  },
  getContexDependendCheckbox: function(nameAttribute) {
    return this.getQuestionByName(`ctx-checkbox-${nameAttribute}`);
  },

  getChecklist: function (nameAttribute) {
    return this.getQuestionByName(`checklist-${nameAttribute}`);
  },

  getRadioQuestion: function (nameAttribute) {
    return this.getQuestionByName(`radio-${nameAttribute}`);
  },

  loadProductByHandle: function (productHandle) {
    return fetch(window.Shopify.routes.root + `products/${productHandle}.js`);
  },


  createCart: function () {
    return this.questionaire.map(question => question.selectedProducts)
      .flat()
      .map(e => ({
       id: e.product.variants[0].id,
       quantity: e.quantity // Adjust the quantity as needed
     }));
  },

  verifyCart: function () {
    let warnings = [];
    var out = [];
    
    let flattenedProducts = this.questionaire
      .map(question => question.selectedProducts)
      .flat();

    if(flattenedProducts.length == 0) {
      out.push("Selecteer eerst wat producten.");
    }

     flattenedProducts.forEach(e => {
        console.log(e);
        if(!e.product.available) {
          warnings.push(`Helaas kan de ${e.product.handle} niet toegevoegd worden, omdat de voorraad niet genoeg is.`);  
        }

        //only display unique warnings once
        var seen = {};
        var len = warnings.length;
        var j = 0;
        for(var i = 0; i < len; i++) {
          var item = warnings[i];
          if(seen[item] !== 1) {
            seen[item] = 1;
            out[j++] = item;
          }
        }

      });
      
      return out;
  }
}

class Question{

  selectedProducts = []; //CartItem
  name = "new";


  //please, for the love of God, make sure name is ALWAYS unique
  constructor(name) {
    this.name = name; 
  }
}

class CartItem {

  constructor(product, variantId, quantity = 1) {
    this.product = product;
    this.variantId = variantId;
    this.quantity = quantity;
  }
}


window['ProductGenerator'] = productGenerator;